import React from 'react'
import ResoucesHero from './ResoucesHero'
import ResourceSection1 from './ResourceSection1'
import Testimonial from '../Home/Testimonial'

const Resources = () => {
  return (
    <div>
        <ResoucesHero/>
        <ResourceSection1/>
        <Testimonial/>
    </div>
  )
}

export default Resources